// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { trackPageView, setClickAnalyticsData } from '@tcp/core/src/analytics/actions';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import { getAPIConfigForAdobe, getUserState } from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import { fetchModuleX } from '../../common/organism/PointsHistory/container/PointsHistory.actions';
import PointsHistoryPageSaga from '../../common/organism/PointsHistory/container/PointsHistory.saga';
import PointsHistoryReducer from '../../common/organism/PointsHistory/container/PointsHistory.reducer';
import {
  getPointHistoryRichTextContentId,
  getPointHistoryRichTextSelector,
} from '../../common/organism/PointsHistory/container/PointsHistory.selectors';
import PointsHistoryPage from '../views';

export class PointsHistoryPageContainer extends React.PureComponent {
  componentDidMount() {
    const { pointHistoryContentId, getRichText, User, APIConfig, session } = this.props;
    getRichText(pointHistoryContentId);

    const pageDataAdobe = {
      pageName: 'point history detail',
      pageSection: 'profile',
      pageSubSection: '',
      pageSubSection2: '',
      pageType: 'profile page',
    };

    pushEventToAdobeAnalytics('page_view', { pageData: pageDataAdobe, User, APIConfig, session });
  }

  /**
   * @function render  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */
  render() {
    const { pointHistoryRichText, ...otherprops } = this.props;
    return <PointsHistoryPage richTextContent={pointHistoryRichText} {...otherprops} />;
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getRichText: (cid) => {
      dispatch(fetchModuleX(cid));
    },
    trackPageLoad: (payload) => {
      dispatch(
        setClickAnalyticsData({
          customEvents: ['event80'],
        })
      );
      dispatch(trackPageView(payload));
      const analyticsdispatchTimeout = setTimeout(() => {
        dispatch(setClickAnalyticsData({}));
        clearTimeout(analyticsdispatchTimeout);
      }, 100);
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    pointHistoryContentId: getPointHistoryRichTextContentId(state),
    pointHistoryRichText: getPointHistoryRichTextSelector(state),
    pageData: {
      pageName: 'point history detail',
      pageSection: 'profile',
      pageSubSection: '',
      pageType: 'profile page',
    },
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
  };
};

PointsHistoryPageContainer.propTypes = {
  pointHistoryContentId: PropTypes.string,
  pointHistoryRichText: PropTypes.string,
  getRichText: PropTypes.func,
  trackPageLoad: PropTypes.func,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
};

PointsHistoryPageContainer.defaultProps = {
  pointHistoryContentId: '',
  pointHistoryRichText: '',
  getRichText: () => {},
  trackPageLoad: () => {},
  User: {},
  APIConfig: {},
  session: {},
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = withDynamicSaga({ key: 'PointsHistorySaga', saga: PointsHistoryPageSaga });
const withReducer = withDynamicReducer({
  key: 'pointHistoryReducer',
  reducer: PointsHistoryReducer,
});

export default compose(withReducer, withSaga, withConnect)(PointsHistoryPageContainer);
